import React, { Component, PropTypes } from 'react';
import first from 'lodash/first';
import reduce from 'lodash/reduce';
import DetailsWrapper from 'single_entry/containers/details_wrapper';

export default class Entry extends Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
  }

  onClose() {
    const {
      router, params, isCreative, isProjectOwner, isProjectCollaborator, lastEntriesQuery
    } = this.props;
    const goToYourEntries = isCreative && !isProjectOwner && !isProjectCollaborator;
    const append = goToYourEntries? 'your-entries' : 'entries';
    const query = goToYourEntries? {} : lastEntriesQuery;
    router.push({
      pathname: `/${params.subcategory}/${params.pageSlug}/${append}/`,
      query: {
        ...query,
        keep_view_type: true,
        keep_grouping: true
      }
    });
  }

  onChangePage(page) {
    const { router, params, location, entryIds } = this.props;
    const entryId = entryIds[page - 1];

    if (entryId) {
      let url = `/${params.subcategory}/${params.pageSlug}/entry/${entryId}/`;
      if (location.query.close_comments === 'true') {
        url = url + '?close_comments=true';
      }
      router.push(url);
    } else {
      this.onClose();
    }
    return Promise.resolve(true);
  }

  render() {
    const { entry, currentRevisionId, location, drawerState } = this.props;
    const revisionsById = reduce(entry.revisions, (mem, revision) => {
      return { ...mem, [revision.id]: revision };
    }, {});
    const firstRevision = first(entry.revisions) || {};

    return (<DetailsWrapper
      drawerState={drawerState}
      entry={entry}
      revisions={revisionsById}
      currentRevision={currentRevisionId || firstRevision.id}
      setPage={this.onChangePage}
      toggleEntryDetails={this.onClose}
      showComments={location.pathname.indexOf('comments') !== -1}
    />);
  }
}

Entry.defaultProps = {
  drawerState: {
    leftDrawerVisible: false,
    entryCommentsVisible: false,
    entryRevisionsVisible: false,
  }
};

Entry.propTypes = {
  entry: PropTypes.object,
  lastEntriesQuery: PropTypes.object,
  currentRevisionId: PropTypes.any,
  entryIds: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  drawerState: PropTypes.object,
  isCreative: PropTypes.bool,
  isProjectOwner: PropTypes.bool,
  isProjectCollaborator: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./single_entry/components/entry.jsx